export const Handle = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '3px',
        padding: '4px',
        cursor: 'grab',
      }}
    >
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          style={{
            width: '20px',
            height: '2px',
            backgroundColor: '#000',
            borderRadius: '1px',
          }}
        />
      ))}
    </div>
  );
};
